import { ButtonGroup, Card, LoadingSpinner, Modal, Tooltip, Icon, TabsNavigation, Tab } from 'pepsico-ds'
import React, { useEffect, useState, useRef } from 'react'
import ModalFilters from './ModalFilters'
import { formatNumberWithCommas, returnHyphenIfNull, handleDomToImgDownloadPdf } from '../../utils/utils'
import { useSelector } from 'react-redux'
import { localStoreKeys } from '../../constants/localStoreKeys'
import { Col, Row, Button, Table } from 'antd'
import InforIcon from "../Icons/InfoIcon";
import CommonTable from '../Table/CommonTable'
import DoubleDonutChart from '../Charts/PieChart/DoubleDonutChart'
import LegendList from '../Charts/Legend/LegendList'
// import MapWithShapes from '../Charts/Map/MapWithCircles'
import RadarChartComponent from '../Charts/ResilincChart/RadarChartComponent'
// import ReactTooltip from 'react-tooltip';
import SingleBarChart from '../Charts/SpendAnalyticsChart/SingleBarChart';
import { urlConstants } from '../../constants/urlConstants';
import NoData from '../NoData/NoData'
import SpendDonutChart from '../Charts/SpendAnalyticsChart/SpendDonutChart'
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import SpendStackedBarChart from '../Charts/SpendAnalyticsChart/SpendStackedBarChart'
import VeridionStackedChart from '../Charts/VeridionChart/VeridionStackedChart';
import InfoIcon from '../Icons/InfoIcon'
import CustomButtons from '../Cards/CustomButtons'
import DropdownWithIcons from './DropdownWithIcons'
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';


const cellDataFunction = (ctx) => {
    const colId = ctx.column.id
    if(ctx.row.original[colId]==null) {
        return <div>-</div>
    }
    // const value = colId==="supplierCount"? formatNumberWithCommas(ctx.row.original[colId]):ctx.row.original[colId] 
    return <div>{ctx.row.original[colId]}</div>; // <div>{value}</div>;//
}
const columns = [
    { columnKey: 'a', header: '' },
    { columnKey: 'studyName', header: "Study Name", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    // { columnKey: 'studyDescription', header: "Study Description", size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'createdOn', header: "Created On", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'contacteEmail', header: "Contact Email", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'bu', header: "Business Unit / Market", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'category', header: "Category (L1)", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    // { columnKey: 'teamName', header: "Team Name", size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'status', header: "Status", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'excludes', header: "Discovered Suppliers", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'includes', header: "Shortlisted Suppliers", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
]

const dataSource = [
    { studyName: 'Food Testing', studyDescription: 'Laboratory', createdOn: '2025-01-21 06:01', contacteEmail: 'emma.brooks@pepsico.com', teamName: "Pavan's Team", status: 'Published', discoveredSuppliers: 'ABC', acceptedSuppliers: 'PQR' }
]

const sampleResilincData = [
    {
        "name": "PRICEWATERHOUSECOOPERS",
        "value": "3",
        "numericValue": 3,
        "unit": ""
    },
    {
        "name": "BAKER BOTTS",
        "value": "2",
        "numericValue": 2,
        "unit": ""
    },
    {
        "name": "SHINY SERVICES",
        "value": "0.03MN",
        "numericValue": 0.03,
        "unit": "MN"
    },
    {
        "name": "DHL EXPRESS",
        "value": "0.02MN",
        "numericValue": 0.02,
        "unit": "MN"
    },
    {
        "name": "QUESS CORP",
        "value": "0.01MN",
        "numericValue": 0.01,
        "unit": "MN"
    },
    {
        "name": "LAW OFFICE OF A ABBOUD AND ASSOCIATES",
        "value": "0.01MN",
        "numericValue": 0.01,
        "unit": "MN"
    },
    {
        "name": "AMERICAN LIFE INSURANCE",
        "value": "0.01MN",
        "numericValue": 0.01,
        "unit": "MN"
    },
    {
        "name": "FREEDOM INTERNATIONAL",
        "value": "0.01MN",
        "numericValue": 0.01,
        "unit": "MN"
    },
    {
        "name": "POLARIS AUTOMATION SYSTEMS",
        "value": "0.009MN",
        "numericValue": 0.009,
        "unit": "MN"
    },
    {
        "name": "EL KHOURY AND PARTNERS LAW FIRM",
        "value": "0.007MN",
        "numericValue": 0.007,
        "unit": "MN"
    },
    {
        "name": "NEXT GENERATION RL",
        "value": "0.003MN",
        "numericValue": 0.003,
        "unit": "MN"
    },
    {
        "name": "GOLIGHT GOURMET",
        "value": "0.001MN",
        "numericValue": 0.001,
        "unit": "MN"
    },
    {
        "name": "BT LEBANON",
        "value": "0.0003MN",
        "numericValue": 0.0003,
        "unit": "MN"
    },
    {
        "name": "SAAD TRANSPORT (LEBANON)",
        "value": "0.0002MN",
        "numericValue": 0.0002,
        "unit": "MN"
    }
]

const tooltipColumns = [
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
    },
    {
        title: "Age",
        dataIndex: "age",
        key: "age",
    },
];

const tooltipData = [
    {
        key: "1",
        name: "John Doe",
        age: 32,
    },
    {
        key: "2",
        name: "Jane Smith",
        age: 28,
    },
];

/**** VERIDION TABLE OBJECTS ******/
const veridionColumns = [
    { columnKey: 'a', header: '' },
    { columnKey: 'studyName', header: "Study Name", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'createdOn', header: "Created On", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'contacteEmail', header: "Contact Email", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'bu', header: "Sector - BU", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'category', header: "Category (L1)", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'status', header: "Status", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'excludes', header: "Discovered Suppliers", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'includes', header: "Shortlisted Suppliers", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
]

const veridionColumnsToInclude = ["STUDY NAME", "CREATED ON", "CONTACT EMAIL", "SECTOR - BU", "CATEGORY (L1)","STATUS", "DISCOVERED SUPPLIERS", "SHORTLISTED SUPPLIERS"]

const veridionColumnMapping = {
    "studyName": "STUDY NAME",
    "createdOn": "CREATED ON",
    "contacteEmail": "CONTACT EMAIL",
    "bu": "SECTOR - BU",
    "category": "CATEGORY (L1)",
    "status": "STATUS",
    "excludes": "DISCOVERED SUPPLIERS",
    "includes": "SHORTLISTED SUPPLIERS"
    }

const veridionScreen2Columns = [
    { columnKey: 'a', header: '' },
    { columnKey: 'sector', header: "Sector", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'bu', header: "BU / Market", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'categoryL0', header: "Category L0", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'categoryL1', header: "Category L1", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'categoryL2', header: "Category L2", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'supplierCount', header: "Supplier Count", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    // { columnKey: 'supplierCount', header: "Supplier Count1", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    // { columnKey: 'supplierCount', header: "Supplier Count2", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
   
]
// const sampleScreen2Data = [
//     {
//       sector: 'AMESA',
//       bu: 'INDIA',
//       categoryL0: 'Raw Materials',
//       categoryL1: 'Metals',
//       categoryL2: 'Aluminum',
//       supplierCount: 45,
//     },
//     {
//       sector: 'PBNA',
//       bu: 'US',
//       categoryL0: 'Raw Materials',
//       categoryL1: 'Metals',
//       categoryL2: 'Aluminum',
//       supplierCount: 10403,
//     },
//     {
//       sector: 'APAC',
//       bu: 'AUSTRALIA',
//       categoryL0: 'Raw Materials',
//       categoryL1: 'Metals',
//       categoryL2: 'Aluminum',
//       supplierCount: 20403,
//     }]
const veridionScreen2ColumnsToInclude = ["SECTOR", "BU / MARKET", "CATEGORY L0", "CATEGORY L1", "CATEGORY L2","SUPPLIER COUNT"]

const veridionScreen2ColumnMapping = {
    "sector": "SECTOR",
    "bu": "BU / MARKET",
    "categoryL0": "CATEGORY L0",
    "categoryL1": "CATEGORY L1",
    "categoryL2": "CATEGORY L2",
    "supplierCount": "SUPPLIER COUNT"
}

/**** VERIDION TABLE OBJECTS End ******/


function VeridionModal({ openModal, setOpenModal, userData, selectedYear, capability, userDataLandingPage, landingPageFilters, appName }) {
    const [loader, setLoader] = useState(true)
    const [veridionData, setVeridionData] = useState({})
    const [tableData, setTableData] = useState([])
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const isLoading = useSelector((state) => state?.loader?.isLoading);
    const [selectedTab, setSelectedTab] = useState(1)
    
    const veridionRef = useRef()
    const supplierSectorBURef = useRef()
    const supplierSectorCategoryRef = useRef()
    const countSectorBURef = useRef()
    const countSectorCategoryRef = useRef()
    const localGlobalSuppliersRef = useRef()

    
    const getVeridionData = (value) => {
        let appList = [];
        if(value?.data?.type==="SUCCESS_VERIDION_DETAIL_VIEW_ACTION") {
            
            setVeridionData(value.data)
            appList = value?.data?.appData
        }
        if (value.modalName == "Veridion" && appList && appList.length > 0) {
            const tempbuttonGroupItems = [
                { 
                    icon: "ondemand_video", 
                    label: "", 
                    onClick: () => window.open(urlConstants.veridionVideo, "_blank") 
                },
                ...(appList
                    ?.filter(item => item.isActive)
                    .map(item => ({
                        label: item.app.replace(" (V)", ""),
                        onClick: () => window.open(item.url, "_blank"),
                    })) ?? [])
            ];

            setButtonGroupItems(tempbuttonGroupItems)
        }
        const currentYear = new Date().getFullYear()
        // setIsYTDDisplay(currentYear == value.fromDateSelected?.[0]?.["displayText"] ? true : false)
    }

    const inputData = veridionData?.supplierStudiesData
    const supplierStudiesData = inputData?.map(item => ({
        ...item,
        createdOn: item.createdOn.replace(" +00:00", "")
    }));
    const naicsSupplierTableData = veridionData?.naicsTableData;
    // console.log("veridionData",supplierStudiesData)
    const sectorCategoryStudyCount = veridionData?.sectorCategoryStudyCount
    const sectorBuStudyCount = veridionData?.sectorBuStudyCount
    const sectorBuColor = veridionData?.sectorBuColor
    const sectorCategoryColor = veridionData?.sectorCategoryColor

    
    const transformedBUData = sectorBuStudyCount?.map(item => ({
        category: item.sector,
        name: item.bu,
        color: item.colorCode?item.colorCode:"#000000",
        sectorColor: item.sectorColorCode?item.sectorColorCode:"#000000",
        value: item.count
      }));
    const uniqueSectorValuesForBUChart = new Set(transformedBUData?.map(item => item.category));
    const multipleSectorFlagForBUChart = uniqueSectorValuesForBUChart?.size > 1;
      
    
    const transformedCategoryData = sectorCategoryStudyCount?.map(item => ({
        category: item.sector,
        name: item.category,
        color: item.colorCode?item.colorCode:"#000000",
        sectorColor: item.sectorColorCode?item.sectorColorCode:"#000000",
        value: item.count
      }));
    const uniqueSectorValuesForCategoryChart = new Set(transformedCategoryData?.map(item => item.category));
    const multipleSectorFlagForCategoryChart = uniqueSectorValuesForCategoryChart?.size > 1;
    
    const suppliersAccepted = veridionData?.headerDetails?.suppliersAccepted
    const numberOfSupplierDiscovered = veridionData?.headerDetails?.numberOfSupplierDiscovered
    const supplierAcceptanceRate = veridionData?.headerDetails?.supplierAcceptanceRate
    const encodedEmailId = localStorage.getItem('userInfoEmailID')
    let userInfoEmailID = ''
    if(encodedEmailId){
         userInfoEmailID = JSON.parse(atob(encodedEmailId));
    }
    // let userInfoEmailID = JSON.parse(atob(localStorage.getItem('userInfoEmailID')));
    const veridionCustomBtnsData = veridionData?.appData?.map(app => {
        return { ...app, url: `https://platform.veridion.com/?sso_hint=${userInfoEmailID}` }; // Creates a new object with the updated URL
    });

    const workInProgress = veridionData?.headerDetails?.workInProgress
    const numberOfStudies = veridionData?.headerDetails?.numberOfStudies
    const published = veridionData?.headerDetails?.published

    const supplierEnrichmentScore = veridionData?.headerDetails?.supplierEnrichmentScore
    const averageDiffToPublish = veridionData?.headerDetails?.averageDiffToPublish


    const localVsGlobalData = veridionData?.localVsGlobal;
    const naicsBUColor = veridionData?.naicsBUColor
    const naicsCategoryColor = veridionData?.naicsCategoryColor

    const naicsCategoryStudyCount = veridionData?.naicsSupplierCountBySectorAndCategory
    const isEDFIntegrated = veridionData?.edfintegrated;
	
    
    const transformedNAICSCategoryData = naicsCategoryStudyCount?.map(item => ({
        category: item.sector,
        name: item.category,
        color: item.color?item.color:"#000000",
        sectorColor: item.color?item.color:"#000000",
        value: Number(item.supplierCount)
      }));
    const dataMap = {};
    const categoryColor = [];
    
    transformedNAICSCategoryData?.forEach(item => {
        const { category, name, color, value } = item;

        if (!dataMap[category]) {
            dataMap[category] = { category };
        }
        dataMap[category][name] = value;

        categoryColor.push({ category, name, color });
    });
    const naicsCategoryStackData = Object.values(dataMap);

    
    const naicsBUStudyCount = veridionData?.naicsSupplierCountBySectorAndBu
    
    const transformednaicsBUData = naicsBUStudyCount?.map(item => ({
        category: item.sector,
        name: item.bu,
        color: item.color?item.color:"#000000",
        sectorColor: item.color?item.color:"#000000",
        value: Number(item.supplierCount)
      }));
    const datanaicsBUMap = {};
    const naicsBUColorData = [];
    
    transformednaicsBUData?.forEach(item => {
        const { category, name, color, value } = item;

        if (!datanaicsBUMap[category]) {
            datanaicsBUMap[category] = { category };
        }
        datanaicsBUMap[category][name] = value;

        naicsBUColorData.push({ category, name, color });
    });
    const naicsBUStackData = Object.values(datanaicsBUMap);


    // const acceptedSuppliersvstotal = veridionData?.suppliersAccepted
    // const tempAcceptedSuppliersvstotal = acceptedSuppliersvstotal?.split('/')
    // const suppliersAcceptanceRate = veridionData?.supplierAcceptanceRate
    // const totalStudies = veridionData?.numberOfStudies
    // const publishedStudies = veridionData?.published
    // const wipStudies = veridionData?.workInProgress
    // const supplierIntelligenceScore = 72
    // const avgPlateformDiscoveryTime = '30 mins'
    // const avgStudayInitiationTime = '3 Days'
    // const platformUtilizationScore = 4 / 5
    const legends = [
        { name: "APAC", color: "#A35079" },
        { name: "PBNA", color: "#007EB5" },
        { name: "AMESA", color: "#33B1E8" },
    ]

    // const acceptedSuppliersvstotal = '3 / 100'
    // const tempAcceptedSuppliersvstotal = acceptedSuppliersvstotal.split('/')
    // const suppliersAcceptanceRate = 3.33
    // const totalStudies = 4
    // const publishedStudies = 1
    // const wipStudies = 3
    // const supplierIntelligenceScore = 72
    // const avgPlateformDiscoveryTime = '30 mins'
    // const avgStudayInitiationTime = '3 Days'
    // const platformUtilizationScore = 4 / 5
    // const legends = [
    //     { name: "APAC", color: "#A35079" },
    //     { name: "PBNA", color: "#007EB5" },
    //     { name: "AMESA", color: "#33B1E8" },
    // ]

    const columnsToInclude = ["STUDY NAME", "CREATED ON", "CONTACT EMAIL", "BUSINESS UNIT / MARKET", "CATEGORY (L1)", "STATUS", "DISCOVERED SUPPLIERS", "SHORTLISTED SUPPLIERS"]

    const columnMapping = {
        "studyName": "STUDY NAME",
        "createdOn": "CREATED ON",
        "contacteEmail": "CONTACT EMAIL",
        "bu": "BUSINESS UNIT / MARKET",
        "category": "CATEGORY (L1)",
        "status": "STATUS",
        "excludes": "DISCOVERED SUPPLIERS",
        "includes": "SHORTLISTED SUPPLIERS"
      }
      // Track modal view when opened
    const MODAL_TITLE = 'Supplier Discovery';

          useEffect(() => {
              if (openModal) {
                  trackModalView(`${MODAL_TITLE} Veridion Analytics Modal`, 'view');
              }
          }, [openModal]);
      
          const handleClose = () => {
              trackModalView(`${MODAL_TITLE} Veridion Analytics Modal`, 'close');
              setOpenModal(false);
          };

          const { showToast } = useToast();


        
    const checkPDFDownloaded = () => {}
    
    
    return (
        <Modal
            onCloseModal={handleClose}
            primaryButtonProps={{
                //onClick: () => setOpenModal(!openModal),
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showAuxiliaryButton={false}
            showSlot={true}
            showModal={openModal}
            closeOnOutsideClick={false}
            hideCloseButton={false}
            type="XL"
            {...getModalAttributes(`${MODAL_TITLE} Veridion Analytics Modal`)}
        >
            <div ref={veridionRef}>
                <div className="modal-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>
                        {userData.FirstName}, the total number of Discovered Suppliers Shortlisted through Veridion is <b>{suppliersAccepted ? formatNumberWithCommas(suppliersAccepted) : 0}</b>
                        {
                            isEDFIntegrated &&
                            <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                                <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                            </Tooltip>
                        }
                    </span>
                    {
                        isLoading ? (
                            <></>
                        ) :                    
                        <>
                            {/* <ButtonGroup
                                style={{ marginRight: '2rem' }}
                                className="buy-con-button-group"
                                items={buttonGroupItems}
                                size="small"
                            /> */}
                            
                        
                            <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    {/* <CustomButtons isModal={true} appList={
                                        [
                                            { icon: 'ondemand_video', label: '', "url": "https://www.youtube.com/watch?v=HoHb6LFbILA", },
                                            ...(Array.isArray(veridionData?.appData) ? veridionCustomBtnsData : [])
                                        ]
                                    }   
                                    /> */}
                                    {/* <button onClick={() => handleDomToImgDownloadPdf(veridionRef, "Veridion_Modal")}>PDF</button> */}
                                    <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.6rem'}}>
                                        <DropdownWithIcons modalRef={veridionRef} kpiName={"Veridion_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded}/>
                                    </span>
                            </span>
                        
                        </>
                    }
                </div>
                
                <div className="modal-update-frequesncy" style={{ marginBottom: "5px", display: "flex", color:"rgb(170, 0, 26)" }}><Icon alt="" icon="info" size="small" /> &nbsp; {"As of Dec'25, POC with Verdion is coming to end, hence historical data will be archived"}</div>
                <div className="modal-update-frequesncy" style={{ marginBottom: "5px", display: "flex" }}><Icon alt="" icon="info" size="small" /> &nbsp; {staticNotes.SUPPLIER_DISCOVERY_EDF_NOTE}</div>
            
                {selectedTab==1 && (veridionData?.lastUpdate) && <div className="modal-update-frequesncy">Data As On: {returnHyphenIfNull(veridionData?.lastUpdate)} | Refresh Frequency: {returnHyphenIfNull(veridionData?.refreshFrequency)}</div>}
                {selectedTab==2 && (veridionData?.naicsLastUpdate) && <div className="modal-update-frequesncy">Data As On: {returnHyphenIfNull(veridionData?.naicsLastUpdate)} | Refresh Frequency: {returnHyphenIfNull(veridionData?.naicsRefreshFrequency)}</div>}
                <ModalFilters modalName={"Veridion"} selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getVeridionData} landingPageFilters={landingPageFilters} setLoader={setLoader} appName={appName} selectedTab={selectedTab} />
                <br />
                {
                    isLoading ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                            <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                        </div>
                        :
                        <>
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop:"5px" }}>
                                <TabsNavigation className="veridion-tabs" selectedIndex={selectedTab-1} style={{}} type="border">
                                    <Tab label="Suppliers Discovered" onClick={function Xs(){setSelectedTab(1)}}/>
                                    <Tab label="NAICS Supplier Database" onClick={function Xs(){setSelectedTab(2)}}/>
                                </TabsNavigation>
                            </div>
                            {/* <hr style={{ height: '1px', backgroundColor: 'rgb(248, 248, 248)', margin: '0px 0px' }}/> */}
                            <br/>
                            <br/>
                            
                            {
                                selectedTab==1 && 
                                <>
                                    <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%", position: 'relative' }}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Card style={{ height: '100%',display:'flex' }}>
                                        <div className='header-kpi-wrapper'>
                                        {
                                            suppliersAccepted === null || suppliersAccepted === undefined ? '' : <>
                                                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                                    <>
                                                        <div className="spend-modal-alphanumeric-value">
                                                            <div className='spend-modal-numeric-value' style={{ color: '#008251' }}>{formatNumberWithCommas(suppliersAccepted)}</div>
                                                            <div className='spend-modal-numeric-value'>/</div>
                                                            <div className='spend-modal-numeric-value' style={{ color: '#005cbc' }}>{formatNumberWithCommas(numberOfSupplierDiscovered)}</div>
                                                        </div>
                                                        <div className='spend-modal-total-spend-text veridion-tooltip'>
                                                            # of suppliers <span style={{ color: '#008251' }}>Shortlisted</span> vs # of suppliers <span style={{ color: '#005cbc' }}>Discovered</span>
                                                            &nbsp;<InforIcon text="This data is only for published Studies" direction='right' />
                                                        </div>
                                                    </>
                                                </Col>
                                            </>
                                        }
                                        {
                                            suppliersAccepted === null || suppliersAccepted === undefined ? '' : <>
                                                <div className="compass-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                                    <>
                                                        <div className="spend-modal-alphanumeric-value">
                                                            <div className='spend-modal-numeric-value' style={{ color: '#008251' }}>{supplierAcceptanceRate || 0}%</div>
                                                            {/* <div className='spend-modal-numeric-value'>/</div>
                                                            <div className='spend-modal-numeric-value' style={{ color: '#94D6F0' }}>{numberOfSupplierDiscovered}</div> 
                                                            */}
                                                        </div>
                                                        <div className='spend-modal-total-spend-text'>Suppliers <span style={{ color: '#008251' }}>Shortlist</span> %</div>
                                                        
                                                    </>
                                                </Col>
                                            </>
                                        }
                                        {
                                            numberOfStudies === null || numberOfStudies === undefined ? '' : <>
                                                <div className="compass-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                                    <>
                                                        <div className="spend-modal-alphanumeric-value">
                                                            <div className='spend-modal-numeric-value'>{numberOfStudies || 0}</div>
                                                        </div>
                                                        <div className='spend-modal-total-spend-text'>Total # of studies: Published ({published || 0}) WIP ({workInProgress || 0})</div>
                                                    </>
                                                </Col>
                                            </>
                                        }
                                        {
                                            numberOfStudies === null || numberOfStudies === undefined ? '' : <>
                                                <div className="compass-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                                    <>
                                                        <div className="spend-modal-alphanumeric-value">
                                                            <div className='spend-modal-numeric-value'>~3 seconds</div>
                                                        </div>
                                                        <div className='spend-modal-total-spend-text'>Average Platform Discovery Time</div>
                                                    </>
                                                </Col>
                                            </>
                                        }
                                        </div>
                                    </Card>
                                    </Col> 
                                    </Row>
                                    <br />

                                    <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div ref={supplierSectorBURef}>
                                                <Card style={{ height: '100%' }} className="archlet-chart-card">
                                                    <div className="archlet-chart-title" >
                                                        # Suppliers Shortlisted by Sector and BUs &nbsp;
                                                        <InforIcon text="This data is only for published Studies" />
                                                        <span style={{float: 'right'}}>
                                                            <DropdownWithIcons modalRef={supplierSectorBURef} kpiName={"# Suppliers Shortlisted by Sector and BUs"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                        </span>
                                                    </div>
                                                    {
                                                        transformedBUData && transformedBUData.length>0 ?
                                                        <>
                                                            <SpendDonutChart countryData={transformedBUData} flag={multipleSectorFlagForBUChart} />
                                                            <LegendList legends={sectorBuColor} />
                                                        </>
                                                        : <NoData />
                                                    }
                                                </Card>
                                            </div>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div ref={supplierSectorCategoryRef}>
                                                <Card style={{ height: '100%' }} className="archlet-chart-card">
                                                    <div className="archlet-chart-title" >
                                                        # Suppliers Shortlisted by Sector and Categories &nbsp;
                                                        <InforIcon text="This data is only for published Studies" />
                                                        <span style={{float: 'right'}}>
                                                            <DropdownWithIcons modalRef={supplierSectorCategoryRef} kpiName={"# Suppliers Shortlisted by Sector and Categories"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                        </span>
                                                    </div>
                                                    {
                                                        transformedCategoryData && transformedCategoryData.length>0 ?
                                                        <>
                                                            <SpendDonutChart countryData={transformedCategoryData} flag={multipleSectorFlagForCategoryChart} />
                                                            <LegendList legends={sectorCategoryColor} />
                                                        </>
                                                        : <NoData /> 
                                                    }
                                                </Card>
                                            </div>
                                        </Col>
                                        <br />

                                    </Row>
                                    <br />
                                    <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            {
                                            supplierStudiesData && supplierStudiesData.length>0?
                                                <div className="ph-table-wrapper">
                                                <CommonTable className={"veridion-table"} columns={veridionColumns} data={supplierStudiesData} tableHeader={"Supplier Projects"} enableSorting={true} columnsToInclude={veridionColumnsToInclude} columnMapping={veridionColumnMapping} tableName={'SUPPLIER STUDIES'}/>
                                                </div>     
                                                :<NoData/>
                                            }
                                            
                                        </Col>
                                    </Row>
                                    <br />
                                </>
                            }

                            {
                                selectedTab==2 &&
                                <>
                                    <div className={"modal-update-frequesncy"}>
                                        Note: The following are the potential suppliers (registered with NAICS) for your category and geography. To explore more and discover new suppliers matching your criteria, kindly proceed to Veridion.
                                    </div>
                                    {
                                        
                                        naicsBUColor && naicsBUColor.length!==1 &&
                                        <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <div ref={countSectorBURef}>
                                                <Card style={{ height: '100%' }}>
                                                    {
                                                        naicsBUStackData && naicsBUStackData.length>0 ?
                                                            <>
                                                                <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                                    Supplier Count by Sectors and BUs
                                                                    <span style={{float: 'right'}}>
                                                                        <DropdownWithIcons modalRef={countSectorBURef} kpiName={"Supplier Count by Sectors and BUs"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                    </span>
                                                                </div>          
                                                                <SpendStackedBarChart categories={naicsBUColorData} data={naicsBUStackData} isVeridionChart={true}/>
                                                                <LegendList legends={naicsBUColor} />
                                                        </> 
                                                        :
                                                            <NoData />
                                                    }
                                                </Card>
                                            </div>
                                        </Col>
                                        </Row>
                                    }
                                    <br />
                                    <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <div ref={countSectorCategoryRef}>
                                                <Card style={{ height: '100%' }}>
                                                    {
                                                        naicsCategoryStackData && naicsCategoryStackData.length>0 ?
                                                            <>
                                                            
                                                                <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                                        Supplier Count by Sectors and Categories  &nbsp;
                                                                        <InfoIcon text={"The difference in # of suppliers (sector-wise) is because of same supplier being registered on multiple NAICS category"} />
                                                                        <span style={{float: 'right'}}>
                                                                            <DropdownWithIcons modalRef={countSectorCategoryRef} kpiName={"Supplier Count by Sectors and Categories"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                        </span>
                                                                </div>
                                                                <SpendStackedBarChart categories={categoryColor} data={naicsCategoryStackData} isVeridionChart={true}/>
                                                                <LegendList legends={naicsCategoryColor} />
                                                        </> 
                                                        :
                                                            <NoData />
                                                    }
                                                </Card>
                                            </div>
                                        </Col>
                                    </Row>
                                    <br />
                                    <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <div ref={localGlobalSuppliersRef}>
                                                <Card style={{ height: '100%' }}>
                                                    {
                                                    localVsGlobalData && localVsGlobalData.length>0 ?
                                                            <>
                                                                <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                                    Distribution of Local vs Global Suppliers
                                                                    <span style={{float: 'right'}}>
                                                                        <DropdownWithIcons modalRef={localGlobalSuppliersRef} kpiName={"Distribution of Local vs Global Suppliers"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                    </span>
                                                                </div>          
                                                                <VeridionStackedChart inputData={localVsGlobalData}/>
                                                                <LegendList legends={[
                                                                    { name: 'Local Supplier', color: '#0078A7' },
                                                                    { name: 'Global Supplier', color: '#B05788' },
                                                                ]} />
                                                        </> 
                                                        : <NoData />
                                                    }
                                                </Card>
                                            </div>
                                        </Col>
                                    </Row>
                                    <br />
                                    <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            {
                                            naicsSupplierTableData && naicsSupplierTableData.length>0?
                                                <div className="ph-table-wrapper">
                                                <CommonTable className={"veridion-table-2"} columns={veridionScreen2Columns} data={naicsSupplierTableData} tableHeader={"NAICS registered potential supplier database"} enableSorting={true} columnsToInclude={veridionScreen2ColumnsToInclude} columnMapping={veridionScreen2ColumnMapping} tableName={'NAICS REGISTERED POTENTIAL SUPPLIER DATABASE'}/>
                                                </div>  
                                                :<NoData/>
                                            }
                                            
                                        </Col>
                                    </Row>
                                    
                                            <br />
                                </>
                            }
                            
                            {/* <Row>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    {
                                        supplierStudiesData && supplierStudiesData.length>0?
                                            <CommonTable className={"forestreet-table"} columns={columns} data={supplierStudiesData} tableHeader={"Supplier Studies"} enableSorting={true} columnsToInclude={columnsToInclude} columnMapping={columnMapping} tableName={'SUPPLIER STUDIES'}/>
                                            :<NoData/>
                                    }
                                    
                                </Col>
                            </Row> */}
                            
                            <br />
                            <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                {
                                    veridionData?.owners?.length > 0 &&
                                    <div style={{width: '100%'}}>Please reach out to {veridionData?.owners?.map((contact, index) => (
                                        <React.Fragment key={index}>
                                            <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                            {index < veridionData?.owners?.length - 1 && ', '}
                                        </React.Fragment>
                                    ))} for any query on the data displayed.</div>
                                }
                                <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                            </div>
                        </>
                }
                <br/>
            </div>
        </Modal >
    )
}

export default VeridionModal